import { useState } from 'react';
import { Layout, Modal } from 'antd';
import HeaderBar from '../../../Layout/HeaderBar';
import FooterBar from '../../../Layout/FooterBar';

import { useTranslation } from 'react-i18next';
import TableList from '../Table';
import InventoryNav from '../InventoryNav';
import { InventoryContextForType, InventoryType } from '../../../modules/inventory/types';
import EditForm from './EditForm';
import AddForm from './AddForm';
import { Badge } from 'components/ui/badge';
import { InventoryTagsMap } from 'Views/SensorOverview/useInventoryTags';

const { Content } = Layout;

interface IHomeViewProps {
  simcards: InventoryContextForType<InventoryType.SIM_CARDS>[];
  inventoryTagsMap: InventoryTagsMap;
}

function InventorySimcards({ simcards, inventoryTagsMap }: IHomeViewProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState<string | null>(null);
  const onClose = () => setVisible(null);

  return (
    <>
      <Layout>
        <HeaderBar />
        <Content className="min-w-0 px-4 py-6 md:px-6">
          <div className="mx-auto max-w-[1600px] space-y-5">
            <InventoryNav />
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <div className="flex items-center gap-3">
                  <h1 className="m-0 text-2xl font-semibold tracking-tight">{t('SIM-kort')}</h1>
                  <Badge variant="secondary">{simcards.length}</Badge>
                </div>
                <p className="mb-0 mt-1 text-sm text-muted-foreground">
                  {t('Søg, find og administrer dit udstyr.')}
                </p>
              </div>
              <AddForm inventoryTagsMap={inventoryTagsMap} />
            </div>
            <TableList
              type={InventoryType.SIM_CARDS}
              data={simcards}
              setVisible={setVisible}
              inventoryTagsMap={inventoryTagsMap}
            />
          </div>
        </Content>
        <FooterBar />
      </Layout>
      <Modal
        title="Ret Simkort"
        open={!!visible}
        confirmLoading={false}
        onCancel={onClose}
        footer={[]}
      >
        {visible && (
          <EditForm
            key={visible}
            id={visible}
            onClose={onClose}
            inventoryTagsMap={inventoryTagsMap}
          />
        )}
      </Modal>
    </>
  );
}

export default InventorySimcards;
